<template>
  <form id="frm_action" class="club-form">
  <div class="p-formgrid">
        <div class="p-card-field div-big">

          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Creator</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <InputText disabled="disabled" v-model="owner_name"/>
              </div>
            </div>
          </div>
          
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Match create team</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <InputText disabled="disabled" v-model="clubs_name"/>
              </div>
            </div>
          </div>
          
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Competition team</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <InputText disabled="disabled" v-model="competition_clubs_name"/>
              </div>
            </div>
          </div>
          
          <div class="p-card-field div-big">
            <label class="p-col-fixed txt-right text bold">Number of players<span class="color">*</span></label>
              <div class="p-col-6 pl-0">
                  <v-select :clearable="false" :disabled="['MATCHED'].includes(model.status)" title="Number of player" id= "id_2" :filterable="false" placeholder="Select" v-model="selNumberOfPlayer" :options="listNumberOfPlayer" label="code" @search="fetchOptionsNumberOfPlayer" class="p-col-width p-inputtext p-component p-filled p-1">
                      <span slot="no-options" @click="$refs.select.open = false">
                          no data
                      </span>
                  </v-select>
                  <input class="input_tmp_validator" id="number_of_player_id">
            </div>
          </div>
          
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Date & Time<span class="color">*</span></label>
            <div class="div-active">
              <div class="d-flex p-col-6 pl-0">
                <div class="p-col-4 px-0">
                  <Calendar v-model="date" :disabled="['MATCHED'].includes(model.status)" dateFormat="M dd, yy" :showIcon="true" @date-select="changeData()"/>
                  <input class="input_tmp_validator" id="date">
                </div>
                <div class="p-col-4 pr-0">
                  <Calendar v-model="time" :disabled="['MATCHED'].includes(model.status)" :timeOnly="true" hourFormat="12" :showIcon="true" icon="pi pi-clock" @date-select="changeData()"/>
                  <input class="input_tmp_validator" id="time">
                </div>
              </div>
            </div>
          </div>
          
          <div class="p-card-field">
            <label class="p-col-fixed bold">Stadium<span class="color">*</span></label>
            <div class="p-col-6 pl-0">
              <v-select :clearable="false" :disabled="['MATCHED'].includes(model.status)" title="Stadium" id= "a1" :filterable="false" placeholder="Select" v-model="selStadium" :options="listStadium" label="name" @search="fetchOptionsStadium" class="p-col-width p-inputtext p-component p-filled p-1">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="stadium_id">
            </div>
          </div>
          
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Match status</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <InputText disabled="disabled" v-model="status"/>
              </div>
            </div>
          </div>
          
          <div class="p-col-6 box-experience">
            <label class="p-col-fixed bold">Scoreboard<span class="color">*</span></label>
            <div class="p-col-6 border position-relative">
              <div class="d-flex align-items-center">
                <div class="p-col-3">
                  
                </div>
                <div class="p-col-4 d-flex justify-content-center">
                  <Avatar :image="owner_logo" class="mr-2" size="large" shape="circle" :style="!owner_logo ? 'background-color:#d4d3d4; color: #ffffff' : null"/>
                </div>
                <div class="p-col-4 d-flex justify-content-center">
                  <Avatar :image="client_logo" class="mr-2" size="large" shape="circle" :style="!client_logo ? 'background-color:#d4d3d4; color: #ffffff' : null"/>
                </div>
                <div class="p-col-1">
                </div>
              </div>
              <div class="d-flex align-items-center" v-for="items, index in match_halfs" :key="index">
                <div class="p-col-3">
                  {{index+1}} half
                </div>
                <div class="p-col-4 number-box">
                  <InputNumber v-model="items.owner_score" :min="0" locale="de-DE" :minFractionDigits="0" buttonLayout="horizontal" class="txt-center border no-border"/>
                </div>
                
                <div class="p-col-4 number-box">
                  <InputNumber v-model="items.client_score" :min="0" locale="de-DE" :minFractionDigits="0" buttonLayout="horizontal" class="txt-center border no-border"/>
                </div>
                <div class="p-col-1 align-items-center d-flex p-0">
                  <Button icon="pi pi-trash" class="p-button-secondary p-button-rounded p-button-text" @click="deleteHalf(index)"/>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <a class="txt-link" @click="addHalf()">Add half</a>
              </div>
              <input class="input_tmp_validator" id="scoreboard">
              <div class="loading-disabled" v-if="['UPCOMING', 'MATCHED'].includes(model.status)"/>
            </div>
          </div>
          
        </div>
    <Toolbar class="fixed-bottom-toolbar">
      <template slot="right">
        <Button
          label="Cancel"
          @click="backToList()"
          class="p-button-warning cancel"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Save'"
          @click="saveData()"
          class="p-button-success save"
        />
        <Button
          v-else
          :label="'Save'"
          @click="saveData()"
          class="p-button-success save"
        />
      </template>
    </Toolbar>
  </div>
  </form>
</template>

<script>
// import CkditorCore from '../CkditorCore';
import DataServices from '@/core/DataServices'
import moment from 'moment';
export default {
  // components: {
  //   CkditorCore
  // },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      status: '',
      owner_name: '',
      clubs_name: '',
      competition_clubs_name: '',
      date: null,
      time: null,
      
      match_halfs: [{
        owner_score: 0,
        client_score: 0
      },{
        owner_score: 0,
        client_score: 0
      }],
      
      owner_logo: null,
      client_logo: null,
      
      listNumberOfPlayer: [],
      listNumberOfPlayerAll: [],
      selNumberOfPlayer: null,
      
      experiences: [],
      validationErrors: {},
      formMode: this.mode,
      
      saving:false,
      time_zone_local : moment.tz.guess(),
      
      listStadium: [],
      listStadiumAll: [],
      selStadium: null,
      statusList: [{ value: 'PROCESSING', label: 'Processing'}, { value: 'UPCOMING', label: 'Upcoming'}, { value: 'MATCHED', label: 'Matched'}]
    }
  },
  async mounted() {
    await this.getListNumberOfPlayer();
    await this.getListStadium();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.selStadium = this.model.stadium ? {id: this.model.stadium.id, name: this.model.stadium.name} : null;
      this.selNumberOfPlayer = this.model.number_of_player ? {id: this.model.number_of_player.id, code: this.model.number_of_player.code + " : " + this.model.number_of_player.code} : null;
      this.status = this.statusList.filter(f => f.value == this.model.status)[0].label;
      this.owner_name = this.model.owner.fullname;
      this.competition_clubs_name = this.model.competition_clubs ? this.model.competition_clubs.club_name : null;
      this.clubs_name = this.model.clubs.club_name;
      this.date = new Date(moment.tz(this.model.date_time, this.time_zone_local));
      this.time = new Date(moment.tz(this.model.date_time, this.time_zone_local));
      this.match_halfs = this.model.match_halfs.length > 0 ? this.model.match_halfs.map(m => { return {owner_score: m.owner_score, client_score: m.client_score} }) : [{
        owner_score: 0,
        client_score: 0
      },{
        owner_score: 0,
        client_score: 0
      }];
      this.owner_logo = this.model.owner_logo;
      this.client_logo = this.model.client_logo;
    }
  },
  methods: {
    changeData() {
      console.log(this.date);
      console.log(this.time);
      
      console.log(new Date(moment.tz(this.date, this.time_zone_local).format("YYYY-MM-DD")+'T'+moment.tz(this.time, this.time_zone_local).format("HH:mm:ss")));
      
    },
  
    async deleteHalf(index) {
      this.match_halfs.splice(index, 1);
    },
    
    async addHalf() {
      this.match_halfs.push({
        owner_score: 0,
        client_score: 0
      })
    },
    
    async getListNumberOfPlayer(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('number_of_player',{"fields" : `id code`}),
        variables: {
          where_key: where_key,
          orderBy:[{created_at : 'asc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, code :e.code + " : " +e.code});
      }
      this.listNumberOfPlayer = list_time;
      this.listNumberOfPlayerAll = list_time;
    },
    async fetchOptionsNumberOfPlayer(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          code:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('number_of_player',{"fields" : `id code`}),
          variables: {
            where_key: where_key,
            orderBy:[{created_at : 'asc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, code :e.code + " : " +e.code});
        }
        this.listNumberOfPlayer = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listNumberOfPlayer = this.listNumberOfPlayerAll
      }
    },
    
    async getListStadium(){
      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('stadium',{"fields" : `id name`}),
        variables: {
          where_key: where_key,
          orderBy:[{created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.name});
      }
      this.listStadium = list_time;
      this.listStadiumAll = list_time;
    },
    
    async fetchOptionsStadium(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('stadium',{"fields" : `id name`}),
          variables: {
            where_key: where_key,
            orderBy:[{created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.name});
        }
        this.listStadium = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listStadium = this.listStadiumAll
      }
    },
    
    backToList() {
      this.$emit('back');
    },
    async validateData() {

      let number_of_player_id = document.getElementById("number_of_player_id");
      if (this.$commonFuction.isEmptyObject(this.selNumberOfPlayer)){
        number_of_player_id.setCustomValidity("Number of player cannot be empty!");
      } else {
        number_of_player_id.setCustomValidity("");
      }
      var date = document.getElementById("date");
      if (this.$commonFuction.isEmptyObject(this.date)){
        date.setCustomValidity("Date cannot be empty!");
      } else {
        date.setCustomValidity("");
      }
      var time = document.getElementById("time");
      if (this.$commonFuction.isEmptyObject(this.time)){
        time.setCustomValidity("Time cannot be empty!");
      } else {
        time.setCustomValidity("");
      }
      var stadium_id = document.getElementById("stadium_id");
      if (this.$commonFuction.isEmptyObject(this.selStadium)){
        stadium_id.setCustomValidity("Stadium cannot be empty!");
      } else {
        stadium_id.setCustomValidity("");
      }
      var scoreboard = document.getElementById("scoreboard");
      if (this.$commonFuction.isEmptyObject(this.match_halfs) || this.match_halfs.length < 2){
        scoreboard.setCustomValidity("Scoreboard cannot be empty!");
      } else {
        scoreboard.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
  
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      
      var params = {
        number_of_player_id: this.selNumberOfPlayer.id,
        stadium_id: this.selStadium.id,
        date_time: new Date(moment.tz(this.date, this.time_zone_local).format("YYYY-MM-DD")+'T'+moment.tz(this.time, this.time_zone_local).format("HH:mm:ss")),
        match_halfs: this.match_halfs,
        score_club_1: this.match_halfs.reduce((a, b)=> a + b.owner_score,0),
        score_club_2: this.match_halfs.reduce((a, b)=> a + b.client_score,0)
      }
        console.log("params",params)
      this.$emit('save', params);
      
    },
    
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
#frm_action {
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  .color{
    color: red!important;
  }
  .text-active{
    padding: 0px!important;
    margin-bottom: 0px!important;
  }
  .div-active{
    display: flex!important;
    margin-bottom: 12px!important;
  }
  .div-active-item{
    max-width: 120px!important;
    width: 50px!important;
    display: flex!important;
    align-items: flex-start!important;
  }
  .div-p{
    text-align: left!important;
    justify-content: left!important;
  }
  .text-distance{
    display: block!important;
  }
  .div-block{
    display: block!important;
    padding-left: 12px!important;
  }
  .div-big{
    padding: 0px!important;
  }
  .label-thumbnail{
    display: unset!important;
    //margin: 12px!important;
  }
  .label-bot-item{
    display: block!important;
    text-align: left!important;
  }
  .div-calenda{
    display: flex!important;
  }
  .bold{
    font-weight: bold!important;
  }
  #div-thumbnail{
    width: 650px!important;
  }
  .link-width{
    width: 650px!important;
    margin-left: 7px!important;
  }
  .color-text{
    color: #808080;
  }
  .div-canlenda-item{
    margin-right: 12px!important;
  }
  .col-12{
    padding-left: 5px!important;
  }
  .p-formgrid .p-card-field{
    padding: unset !important;
  }
  .p-col{
    padding: 0px!important;
  }
  .p-col-fixed{
    padding: 0px!important;
  }
  /* .p-calendar-w-btn{
    width: 319px!important;
  } */
  .width-thum{
    margin-top: 12px!important;
  }
    //.pi-check{
    //  background-color:#E73725 !important;
    //  border: 1px solid #E73725;
    //}

    .save{
      background-color: #E73725!important;
      border: 1px solid #E73725!important;
    }
    .cancel{
      border: 1px solid #E73725!important;
      color: #E73725!important;
    }
    .one-active{
      margin-left: 5px!important;
    }
    
    .transform-upper-case {
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
      padding: 7px;
  }
    
  .p-component:disabled {
    background-color: #EEEEEE;
    border-color: #D0D4D9;
    color: #666666;
  }  
  .chip__select_multi{
    background-color: #F2F3F7;
    .p-chip-text {
      color: #000;
    }
  }

  .cus-tags{
    border-radius: 18px;
    padding: 8px;
    margin-right: 10px;
    background-color:#F2F3F7;
  }
  .cs-tag {
    padding: 10px 12px 10px 0px;
  }
  .cs-icon {
    color : #666666;
    padding-right: 4px;
    cursor: pointer;
  }

  #id_69 .vs__selected {
    display: none;
  }

  .p-inputnumber.p-component.p-inputwrapper-filled.p-inputnumber-buttons-horizontal input{
    text-align: center !important;
  }

  .box-experience {
    .border {
      border-radius: 5px;
    }
  }
  .border {
    border-color: #D0D4DA !important;
  }
    
  .no-border input {
      color: #000 !important;
      text-align: center !important;
      outline: unset !important;
      box-shadow: unset !important;
      border-color: unset !important;
      border: unset !important;
  }
  .number-box {
    input, button span {
      font-weight: bold;
      color: #666666;
    }
  }

  .vs__dropdown-option--highlight {
    background-color: #E73725 !important;
  }

  .club-form .p-formgrid .p-card-field .p-field .p-col-width {
    width: 100% !important;
  }

  .p-avatar-circle img {
    border-radius: 50%;
  }

  .p-avatar.p-avatar-lg {
      width: 4rem !important;
      height: 4rem !important;
  }
  .loading-disabled {
    position: absolute;
    background-color: #000;
    opacity: .1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: no-drop;
  }
  .vs--disabled *{
    background-color: #EEEEEE;
    color: #666666;
  }
  .vs--disabled .vs__selected-options {
    background-color: transparent !important;
  }
}
</style>
